
import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, Pipe, PipeTransform } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';


import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { AssestManagementComponent } from '../../assest-management/assest-management.component';
import { ElcmCreateEmailTempletComponent } from '../elcm-create-email-templet/elcm-create-email-templet.component';
import * as saveAs from 'file-saver';
import { environment } from 'src/environments/environment';
import { AddDeptLocComponent } from '../add-dept-loc/add-dept-loc.component';

import { MatSnackBar } from '@angular/material/snack-bar';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { AddRatingStanderdsComponent } from '../add-rating-standerds/add-rating-standerds.component';
import { PDFDocument } from 'pdf-lib';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';
import { NoDueFormComponent } from '../no-due-form/no-due-form.component';

@Component({
  selector: 'app-elcm',
  templateUrl: './elcm.component.html',
  styleUrls: ['./elcm.component.scss'],
})
export class ElcmComponent implements OnInit {

  selectedTypeTabName: any = 'Dashboard';
  selectedTypeTabIndex: any = 0;
  buttonColorName: any;
  subModuleButtonColor: any | null;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoles: any;
  loggedInUserName: any | null;
  loggedInUserRoleIsEmployee: boolean = false;
  originalData: any;
  showSetupPopup: boolean = false;
  competencyListManagerView: any;
  showImportPopup: boolean = false;
  selectedManagerDashboardId: boolean = false;
  selectedEmployeeDashboardId: any;
  selectedYearForCompetency: any = null;
  pmsYears: any = [];


  comparisonEmpIdsForSecondLast: any = [];
  selectedOption: any;
  selectedEmpYearonYear: any = [];
  selectedYearForGraphTwoHRAdmin: any = null;
  selectedYearForGraphFifthHRAdmin: any = null;
  selectedYearForGraphSix: any = null;
  selectedYearForGraphNineHRAdmin: any = null;
  selectedYearForGraphTenHRAdmin: any = null;
  weightageWiseCompetenciesGraphData: any[] = [];
  graphDataForLineGraph: any[] = [];
  selectedYearForGraphOneHRAdmin: any = null;
  fromYear: any = null;
  toYear: any = null;
  selectedOptionSalaryBreakUp: any;
  selectedcodecreateOption: any;
  signContent: any;
  letterContent: any;
  signfileName: any;
  signfileType: any;
  letterheadfileName: any;
  letterheadfileType: any;
  setLimit: any = '';
  setPrefix: any;
  selectedDeptLocation: any = null;
  selectedTypeTabNameForSetUp: any = "offerAndAppoinment";
  loggedInUserEmployeeCode: any;
  userEmail: any
  uniqueId: any;
  checkStatus: any;
  constructor(private datePipe: DatePipe, public sharedService: SharedService, private cdr: ChangeDetectorRef,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute, private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    public mobileResponsiveService: MobileResponsiveService,
    public dialogRef: MatDialogRef<ElcmComponent>,
    private ngZone: NgZone
  ) {

  }

  ngOnInit() {

    this.activatedroute.paramMap.subscribe(params => {
      this.checkparams = params;
    });
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserEmployeeCode = sessionStorage.getItem('empCode');
    this.userEmail = sessionStorage.getItem('userEmail');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }


    // this.getAllUser()

    this.getpmsyearlist();
  }

  tabTypeChanged(event: MatTabChangeEvent) {

    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;


  }
  allowOnlyDigits(event: KeyboardEvent): void {
    const charCode = event.key;
    if (!/^[0-9]$/.test(charCode)) {
      event.preventDefault(); // block non-digit
    }
  }
  setuptabTypeChanged(event: MatTabChangeEvent) {
    this.selectedTypeTabNameForSetUp = event?.tab.textLabel;

    if (this.selectedTypeTabNameForSetUp == 'exitsetup') {
      this.getAssignExit();
    } else {
      this.getprobationPeriods();
      this.checkSetUp()
    }
  }
  generateCode(prefix: string, limit: string, dept: string = '', location: string = ''): string {
    let code = prefix + limit; // Start with prefix and limit

    if (dept) {
      code += dept; // Add department if provided
    }

    if (location) {
      code += location; // Add location if provided
    }

    return code;
  }
  selectedTypeTabIndexForReport: any;
  selectedTypeTabNameForReport: any = 'dumpReport';
  tabTypeChangedForReport(event: MatTabChangeEvent) {

    this.selectedTypeTabNameForReport = event.tab.textLabel;
    this.selectedTypeTabIndexForReport = event?.index;


  }
  checkparams: any;
  getStatusFlag: boolean = false

  ionViewWillEnter() {
    this.activatedroute.params.pipe(take(1)).subscribe((params: any) => {
      console.log("ionViewWillEnter called once");
      this.getBAndAndGrade()
      setTimeout(() => {
        this.getStatusFlag = JSON.parse(sessionStorage.getItem("statusFlagCheck") || 'false');

        // this.flag = JSON.parse(sessionStorage.getItem('probationData') || 'false');
        // console.log("flag", this.flag);

      }, 100)

      let storedData = sessionStorage.getItem('sidebarNames');
      let checkmoduleName = storedData ? JSON.parse(storedData) : [];
      let modulename = checkmoduleName.filter((elm: any) => elm.moduleName == 'ELCM');

      if (modulename.length && modulename[0].moduleName === 'ELCM') {
        this.selectedTypeTabName = 'Dashboard';
        this.selectedTypeTabIndex = 0;

        if (params?.operation == 'Setup') {
          // this.getBAndAndGrade();
          this.checkSetUp()// ✅ will run only once
          
        }
      }

      if (params?.operation === 'Setup') {
        if (['HR Admin', 'Super Admin', 'PHI Admin', 'MD'].includes(this.loggedInUserRole)) {
          this.showSetupPopup = true;
        }
      } else if (params?.operation === 'import') {
        if (['HR Admin', 'Super Admin', 'PHI Admin', 'MD'].includes(this.loggedInUserRole)) {
          this.showImportPopup = true;
        }
      } else {
        if (['HR Admin', 'Admin', 'Super Admin', 'PHI Admin', 'MD'].includes(this.loggedInUserRole)) {
          // this.getDepartmentsByCompany();
        } else if (this.loggedInUserRole === 'Finance') {
          this.selectedManagerDashboardId = true;
        } else {
          this.selectedEmployeeDashboardId = this.loggedInUserId;
        }
      }
    });
  }
  statusFlag: any // default

  // checkSetUp() {
  //   this.httpService
  //     .callGetService(
  //       this.config.ckeckSetUpCompleted +
  //       '/' +
  //       this.loggedInUserCompanyID +
  //       '?year=' +
  //       this.selectedYearForCompetency
  //     )
  //     .subscribe((data: any) => {
  //       // 👇 if your API directly returns an array
  //       const setupInfo = Array.isArray(data) ? data[0] : data?.data?.[0];

  //       if (setupInfo) {
  //         const exitSetupStatus = setupInfo.forExitNoticePeriodSetup?.[0]?.status ?? false;
  //         const allSetupStatus = setupInfo.forAllSetup?.[0]?.status ?? false;
  //         // ✅ Final flag
  //         this.statusFlag = allSetupStatus;

  //         // Store in session storage as string ("true"/"false")
  //         sessionStorage.setItem("statusFlagCheck", JSON.stringify(this.statusFlag));

  //         this.flag = JSON.parse(sessionStorage.getItem('probationData') || 'false');
  //       } else {
  //         this.statusFlag = false;
  //         sessionStorage.setItem("statusFlagCheck", "false");
  //       }
  //     });
  // }
checkSetUp() {
  this.httpService
    .callGetService(
      `${this.config.ckeckSetUpCompleted}/${this.loggedInUserCompanyID}?year=${this.selectedYearForCompetency}`
    )
    .subscribe({
      next: (data: any) => {
        console.log('🔹 Raw API response:', data);

        // Handle both array or object-based responses
        const setupInfo = Array.isArray(data) ? data[0] : data?.data?.[0];
        console.log('🔹 Extracted setupInfo:', setupInfo);

        // Get previously stored flag to maintain consistency
        const storedFlag = JSON.parse(sessionStorage.getItem('statusFlagCheck') || 'false');

        if (setupInfo) {
          const exitSetupStatus =
            setupInfo.forExitNoticePeriodSetup?.[0]?.status ?? false;
          const allSetupStatus =
            setupInfo.forAllSetup?.[0]?.status ?? false;

          console.log('🔹 Exit Setup Status:', exitSetupStatus);
          console.log('🔹 All Setup Status:', allSetupStatus);

          // ✅ Once true, keep it true even if API later gives false
          this.statusFlag = storedFlag || allSetupStatus;

          // Save back to session storage
          sessionStorage.setItem(
            'statusFlagCheck',
            JSON.stringify(this.statusFlag)
          );

          // Retrieve probation data safely
          this.flag = JSON.parse(
            sessionStorage.getItem('probationData') || 'false'
          );
        } else {
          // If no data returned, keep previous flag
          this.statusFlag = storedFlag;
          sessionStorage.setItem(
            'statusFlagCheck',
            JSON.stringify(this.statusFlag)
          );
        }

        console.log('✅ Final Status Flag:', this.statusFlag);
      },
      error: (err) => {
        console.error('❌ checkSetUp() API Error:', err);
        // fallback to stored value on API error
        this.statusFlag = JSON.parse(
          sessionStorage.getItem('statusFlagCheck') || 'false'
        );
      },
    });
}

  empStatus: any = 1;
  reportingManager: any;
  getAllUser() {
    const request = {
      "search": '',
      "userType": null,
      "status": this.empStatus,
      "companyId": this.loggedInUserCompanyID,
      "loggedInUserRole": this.loggedInUserRole,
    }
    this.loader.simpleLoaderWithDuration();
    this.httpService.callPostService(this.config.searchEmployeeMaster + '?page=' + 0 + '&size=' + 100, request)
      .subscribe((data: any) => {
        this.loader.dismissLoader();

        console.log(data.data.users);
        let reportingManager = data.data.users.map((elm: any) => elm.reportingManagerCode);
        console.log(reportingManager);
        this.reportingManager = reportingManager.includes((this.loggedInUserEmployeeCode));
        this.httpService.reportingManagerForElcm = this.reportingManager;


      }, (error: any) => {
        this.loader.dismissLoader();
      }, () => { });
  }








  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
      // Additional function calls
      if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Manager') {


        this.chckPRobationEmployee()
      }
      // this.getAllEmployeeCodeData();
      this.getConfirmation();
      // this.getUploadLetterHead();
      // this.getUploadSign();
      // this.getBAndAndGrade();
      this.checkForSameHODORMANAGER();
      this.getAssignExit();

      // this.getSalaryBreckUpData();
      // this.getprobationPeriods();

      this.commanSetUpGetApiData();


    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForCompetency = selectedYearObj?.year;
      this.selectedYearForGraphOneHRAdmin = selectedYearObj?.year;
      this.selectedYearForGraphTwoHRAdmin = selectedYearObj?.year;
      this.selectedYearForGraphFifthHRAdmin = selectedYearObj?.year;
      this.selectedYearForGraphSix = selectedYearObj?.year;
      this.selectedYearForGraphNineHRAdmin = selectedYearObj?.year;
      this.selectedYearForGraphTenHRAdmin = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
    }
  }
  flag: any;
  commanSetUpGetApiData() {
    this.httpService.callGetService(`${this.config.commanSetUpGetApi}=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}`).subscribe(

      (result: any) => {

        sessionStorage.setItem("flagData", result?.data)

        if (result && result.data?.fileData?.latestFiles?.Offerletter != null) { // Check for string "null"
          this.letterheadFilleFromBackendSide = result.data?.fileData?.latestFiles?.Offerletter;// Assign valid data
          this.filleFromBackendSide = result.data?.fileData?.latestFiles?.Offerletter

          this.showletterHeadBrowseBtn = true;
        } else {
          console.log(this.letterheadFilleFromBackendSide);
          this.letterheadFilleFromBackendSide = null; // Ensure it's empty if "null" or actually null

          this.showletterHeadBrowseBtn = false;
        }

        if (result.data?.fileData?.latestFiles?.SIGNATURE != null) { // Check for string "null"
          console.log(result.data?.fileData?.latestFiles?.SIGNATURE);

          this.checkbackendDataForSign = result.data?.fileData?.latestFiles?.SIGNATURE;
          this.signfileNameForApiAppend = result.data?.fileData?.latestFiles?.SIGNATURE; // Assign valid data
          this.showSignBrowseBtn = true;


        } else {
          this.signfileNameForApiAppend = ''; // Ensure it's empty if "null" or actually null
          this.showSignBrowseBtn = false;
          this.isDisabledUploadPolicyBtnForSign = true
        }
        if (result.data?.companyPrefixData) {
          this.getEmployeeCodeDataList = result.data?.companyPrefixData;
          console.log(this.getEmployeeCodeDataList);

          this.flagData = result.data?.companyPrefixData;
          this.updateFlag = this.getEmployeeCodeDataList.length > 0 ? true : false;
          this.setPrefix = this.getEmployeeCodeDataList[0]?.companyPrefix;
          this.setLimit = this.getEmployeeCodeDataList[0]?.startNumber;
          this.selectedDeptLocation = this.getEmployeeCodeDataList[0]?.employeeCodeSelection || 'none';
          this.selectedcodecreateOption = this.getEmployeeCodeDataList[0].isManual ? 'manual' : 'auto';
          this.httpService.setEmployeeCodeData(this.getEmployeeCodeDataList[0]);


        }
        if (result.data?.salaryBreakup && result.data.salaryBreakup.length > 0) {

          // ✅ get the last record
          let lastObject = result.data.salaryBreakup[result.data.salaryBreakup.length - 1];

          this.updateSalarybreckupID = lastObject?.id;

          this.selectedOptionSalaryBreakUp = lastObject?.isSalaryBreakup
            ? 'Yes'
            : lastObject?.isSalaryBreakup == null
              ? null
              : 'No';

          this.selectedOptionForAppoinmentLetter = lastObject?.isAppointment
            ? 'Yes'
            : lastObject?.isAppointment == null
              ? null
              : 'No';

          this.httpService.selectedOptionSalaryBreakUp = lastObject?.isSalaryBreakup;
          this.httpService.selectedOptionForAppoinmentLetter = lastObject?.isAppointment;

          console.log(this.httpService.selectedOptionForAppoinmentLetter);

          this.hasInvalidCode = this.probstionPriodsData?.some((bandItem: any) =>
            bandItem.grades.some((gradeItem: any) => gradeItem.probationId == null)
          );



        }
        this.checkSetUp();
        // this.getStatusFlag = JSON.parse(sessionStorage.getItem("statusFlagCheck") || 'false');
        setTimeout(() => {
          this.getStatusFlag = JSON.parse(sessionStorage.getItem("statusFlagCheck") || 'false');
        }, 100)

      })
  }


  toBoolean(val: any): boolean {
    // handle "Yes"/"No", true/false, 1/0 safely
    return val === true || val === 'true' || val === 'Yes' || val === 1;
  }
  operation: any
  onClickSetup(operation: any) {
    this.operation = operation;
    this.router.navigate(['/home/hrportal/elcm', { operation: operation }]);
    // this.getBAndAndGrade();

  }

  onClickLogs(moduleName: any) {
    this.router.navigate(['/home/hrportal/elcm-logs', { moduleName: moduleName, id: 0 }]);
  }
  getYearSetupForReimbursement() {

  }
  preventNegative(event: KeyboardEvent) {
    if (event.key === '-' || event.key === 'e' || event.key === '.') {
      event.preventDefault();
    }
  }

  getEmployeeCodeDataList: any = [];
  updateFlag: boolean | undefined;
  flagData: any = []

  hasInvalidCode: boolean = false
  onSelectionChangeForWantLimit(event: any) {
    this.hasInvalidCode = this.probstionPriodsData?.some((bandItem: any) =>
      bandItem.grades.some((gradeItem: any) => gradeItem.probationId == null)
    );

    if (this.hasInvalidCode) {
      // Open the dialog without resetting selection initially
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Probation period is required for all grades',
          btn2: 'OK',
          btn2BgColor: 'red',
          showSuccessIcon: false,
          showSuccessMessage: false
        }
      });

      // Handle the dialog result after it's closed
      dialogRef.afterClosed().subscribe((result: any) => {
        console.log(result);  // Logs the result of the dialog

        // Reset the selection after closing the dialog
        this.selectedcodecreateOption = null;

        // Trigger change detection to update the UI
        this.cdRef.detectChanges();
      });

      return;
    }


    // Proceed with confirmation dialog if no issue
    if (!this.hasInvalidCode) {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: `Are you sure you want to select "${event}"?`,
          btn2: 'Yes',
          btn1: 'No',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false,
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        console.log(result);

        if (result) {
          this.selectedcodecreateOption = event;
          if (event === 'manual') {
            this.saveData();
          }
        } else {
          this.selectedcodecreateOption = null; // Reset selection
        }

        // Force UI refresh after setting value
        setTimeout(() => {
          this.cdRef.detectChanges();
        });
      });
    }
  }

  async showToast(message: string, color: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      color: color,
      position: 'top'
    });
    await toast.present();
  }

  validateMaxDays(event: KeyboardEvent) {
    const input = (event.target as HTMLInputElement).value;
    const newValue = Number(input + event.key);

    // Block negative sign, plus sign, non-numeric, or value > 365
    if (event.key === '-' || event.key === '+' || isNaN(Number(event.key)) || newValue > 365) {
      event.preventDefault();
    }
  }


  // =====================================
  onSelectionChangesalaryAndAppoinment(selectedValue: string, event: Event) {
    event.preventDefault();
    event.stopPropagation();

    const previousSelection = this.selectedOptionSalaryBreakUp;

    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: `Are you sure you want to select "${selectedValue}"?`,
        btn2: 'Yes',
        btn1: 'No',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);

      if (result === true) {
        console.log(selectedValue);

        this.selectedOptionSalaryBreakUp = selectedValue;
        this.savesalaryinfo();
        return;
      } else {
        this.selectedOptionSalaryBreakUp = previousSelection;
      }
      // this.getSalaryBreckUpData();
      this.commanSetUpGetApiData();
      this.cdRef.detectChanges();
    });
  }

  // =========================================================
  onSelectionChangeAppoinment(selectedValue: string, event: Event) {
    event.preventDefault();
    event.stopPropagation();

    const previousSelection = this.selectedOptionSalaryBreakUp;

    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: `Are you sure you want to select "${selectedValue}"?`,
        btn2: 'Yes',
        btn1: 'No',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);

      if (result === true) {
        console.log(selectedValue);

        this.selectedOptionForAppoinmentLetter = selectedValue;
        this.savesalaryinfo();

        return;
      } else {
        this.selectedOptionForAppoinmentLetter = previousSelection;
        // this.getSalaryBreckUpData();
        this.commanSetUpGetApiData();
      }

      this.cdRef.detectChanges();
    });
  }
  selectedOptionForAppoinmentLetter: any;

  savesalaryinfo() {
    // Create base form data with common fields
    const baseFormData = {

      "isSalaryBreakup": this.selectedOptionSalaryBreakUp == 'Yes' ? true : this.selectedOptionSalaryBreakUp == 'No' ? false : null,
      "isAppointment": this.selectedOptionForAppoinmentLetter == 'Yes' ? true : this.selectedOptionForAppoinmentLetter == 'No' ? false : null,
      "companyId": this.loggedInUserCompanyID
    };

    // Determine if creating new record or updating existing
    const isNewRecord = !this.updateSalarybreckupID;

    // Define endpoint and data based on operation type
    const endpoint = isNewRecord
      ? `${this.config.salaryBrekUp}`
      : `${this.config.salaryBrekUpUpdate}/${this.updateSalarybreckupID}`;

    // Add additional fields only for new records
    const formData = isNewRecord
      ? {
        ...baseFormData,
        "fiscalYear": this.loggedInCompanyFiscalyear,
        "year": this.selectedYearForCompetency
      }
      : baseFormData;

    // Choose appropriate HTTP method
    const httpMethod = isNewRecord
      ? this.httpService.callPostService
      : this.httpService.callPutService;

    // Make API request
    httpMethod.call(this.httpService, endpoint, formData).subscribe((data: any) => {
      if (data) {
        this.showSuccessDialog(data.message);
        // this.getSalaryBreckUpData();
        this.commanSetUpGetApiData();
      }
    });
  }

  // Extract dialog creation to a separate method
  private showSuccessDialog(message: string) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: 'OK',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: true,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });

    // Empty callback since we're not doing anything after dialog closes
    dialogRef.afterClosed().subscribe(() => { });
  }

  grtsalaryBreackUpdata: any = [];
  setupNotCompleted: any;
  updateSalarybreckupID: any;
  checkanydaysEmpty: any;
  getSalaryBreckUpData() {
    this.httpService.callGetService(`${this.config.getSalaryBrekUp}/${this.loggedInUserCompanyID}`,).subscribe((record: any) => {


      this.grtsalaryBreackUpdata = record.data.filter((elm: any) => elm?.year == this.selectedYearForCompetency)
      this.selectedOptionSalaryBreakUp = '';
      this.selectedOptionForAppoinmentLetter = '';
      let lastObjects = this.grtsalaryBreackUpdata.filter((elm: any) => elm?.companyId == this.loggedInUserCompanyID);
      if (lastObjects) {
        let lastObject = lastObjects[0];
        this.updateSalarybreckupID = lastObject?.id;
        this.selectedOptionSalaryBreakUp = lastObject?.isSalaryBreakup ? 'Yes' : lastObject?.isSalaryBreakup == null ? null : 'No'
        this.selectedOptionForAppoinmentLetter = lastObject?.isAppointment ? 'Yes' : lastObject?.isAppointment == null ? null : 'No'
        this.httpService.selectedOptionSalaryBreakUp = lastObject?.isSalaryBreakup;
        this.httpService.selectedOptionForAppoinmentLetter = lastObject?.isAppointment;
        console.log(this.httpService.selectedOptionForAppoinmentLetter);
        this.hasInvalidCode = this.probstionPriodsData?.some((bandItem: any) =>


          bandItem.grades.some((gradeItem: any) => gradeItem.probationId == null)
        );
        this.checkanydaysEmpty = this.probstionPriodsData?.some((bandItem: any) =>
          bandItem.grades.some((gradeItem: any) => gradeItem.probationId == null || gradeItem.extensionPeriod == null || gradeItem.probationPeriod == null)
        );
        this.httpService.notcompletedElcmSetUp = this.hasInvalidCode || !this.selectedOptionSalaryBreakUp || !this.selectedcodecreateOption || !this.letterheadFilleFromBackendSide;
        let commanArray = [
          { "probation": this.hasInvalidCode },
          { "salary": lastObject },
          { "employeecode": this.getEmployeeCodeDataList },
          { "letterHead": this.letterheadFilleFromBackendSide }
        ];

        this.httpService.setnotcompletdSetUP(commanArray);
      }
    })
  }
  saveData() {
    if (this.selectedcodecreateOption == 'auto') {

      if (this.setPrefix == null || (this.setPrefix == '')) {
        this.showToast('prefix required!', 'danger');
        return
      } else if (this.setLimit == null || (this.setLimit == '')) {
        this.showToast('set limit required!', 'danger');
        return
      } else if (this.selectedcodecreateOption == null || (this.selectedcodecreateOption == '')) {
        this.showToast('selected code create option is required!', 'danger');
        return
      }
    }
    let formData = {
      // "id":this.getEmployeeCodeDataList?this.getEmployeeCodeDataList.id:null,
      "companyPrefix": this.setPrefix,
      "startNumber": this.setLimit,
      "employeeCodeSelection": this.selectedDeptLocation == 'none' ? null : this.selectedDeptLocation,
      "hrId": this.loggedInUserId,
      // "changeByUserId":this.loggedInUserId,
      "companyId": this.loggedInUserCompanyID,
      "isManual": this.selectedcodecreateOption == 'auto' ? false : true,
      // "fiscalYear": this.loggedInCompanyFiscalyear,
      "year": this.selectedYearForCompetency
    }
    let updateFromData = {
      "companyPrefix": this.setPrefix
    }
   
    
    if (this.getEmployeeCodeDataList.length == 0) {

      this.httpService.callPostService(`${this.config.employeeCodeCreate}`, formData).subscribe((data: any) => {


        if (data) {

          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: "Added Successfully",
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe(() => {
            this.dialogRef.close();
          });
          // this.getAllEmployeeCodeData();
          this.commanSetUpGetApiData();
        }
      },
        (error: any) => {

          const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: error.error.error || 'An error occurred while processing your request. Please try again.',
              btn2: 'OK',
              btn2BgColor: 'red', // Highlight error with red button color
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: true
            }
          });

          errorDialogRef.afterClosed().subscribe(() => {
            // Optionally handle any action after closing the error dialog
            console.log('Error dialog closed');
          });
        }
      );
    } else {
  
      this.httpService.callPutService(`${this.config.employeeCodeUpdate}/${this.getEmployeeCodeDataList[0]?.companyCodeId}`, updateFromData).subscribe((data: any) => {


        if (data) {

          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe(() => {
            this.dialogRef.close();
          });
          // this.getAllEmployeeCodeData();
          this.commanSetUpGetApiData();
        }
      },
        (error: any) => {

          const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: error.error.error || 'An error occurred while processing your request. Please try again.',
              btn2: 'OK',
              btn2BgColor: 'red', // Highlight error with red button color
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: true
            }
          });

          errorDialogRef.afterClosed().subscribe(() => {
            // Optionally handle any action after closing the error dialog
            console.log('Error dialog closed');
          });
        }
      );
    }
  }



  onClickOpenCreateSurveyPopup(popupName: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      popupName: popupName,
      data: this.getEmployeeCodeDataList,
      companyYear: this.selectedYearForCompetency,
      elcmModule: "elcm"
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(ElcmCreateEmailTempletComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {


    });
  }


  addDeptAndLoc(popupName: any) {
    console.log("this.getEmployeeCodeDataList", this.getEmployeeCodeDataList);

    if (!this.flagData) {
      const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: "Employee code dose not save",
          btn2: 'OK',
          btn2BgColor: 'red', // Highlight error with red button color
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: true
        }
      });
      return
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '60%';
    dialogConfig.data = {
      popupName: popupName,
      employeeData: this.getEmployeeCodeDataList[0],
      setLimit: this.setLimit,
      setPrefix: this.setPrefix,
      companyId: this.loggedInUserCompanyID,
      changeByUserId: this.loggedInUserId,
      year: this.selectedYearForCompetency,
      fiscalYear: this.loggedInCompanyFiscalyear,
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(AddDeptLocComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {


    });

    // -------------------------For Department-----------------------------------


    // --------------------------End Department----------------------------------







  }
  //------------------------------------------------------upload File-----------------------------------------------------


  getIncrementFyYearList: any = []
  FormYear: any
  ToYear: any
  fileName: any = null;
  fileType: any = null;
  formData: any = new FormData();
  formDataForSign: any = new FormData();
  formDataForletterHead: any = new FormData();
  selectedYear: any;
  companyYears: any[] = [];

  letterHeadUrl: any;
  isDisabled: boolean = false;
  isFileSizeIsInvalid: boolean = false;
  isIncrementLetterCreateContent: any = false
  showBrowseBtn: boolean = false;
  showSignBrowseBtn: boolean = false;

  getUploadIncrementPolicyYear: any = []
  isDisabledUploadPolicyBtn: boolean = true;
  typeofupload: any;
  showletterHeadBrowseBtn: boolean = false;



  triggerFileInput(event: any) {
    this.typeofupload = event;
    const fileInput = document.querySelector('#browseImage') as HTMLInputElement;
    if (fileInput) {
      fileInput.click(); // Programmatically trigger the click event
    }

  }

  fileContent: any;
  isDragging: boolean = false; // Track drag state

  onDragOver(event: DragEvent) {
    event.preventDefault(); // Prevent the default browser behavior
    this.isDragging = true; // Indicate that the file is being dragged
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false; // Reset the drag state
  }

  onFileDropped(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false; // Reset the drag state

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handleFile(files[0]); // Process the first file
    }
  }

  onFileSelected(event: Event) {
    const inputEvent = event.target as HTMLInputElement;
    if (inputEvent.files && inputEvent.files.length > 0) {
      this.handleFile(inputEvent.files[0]); // Process the selected file
    }
  }


  // For sign drag and drop 

  triggerFileInputSign() {

    const fileInput = document.querySelector('#browseSignImage') as HTMLInputElement;
    if (fileInput) {
      fileInput.click(); // Programmatically trigger the click event
    }

  }
  isDraggingSign: boolean = false;
  onDragOverSing(event: DragEvent) {
    console.log(event);

    event.preventDefault(); // Prevent the default browser behavior
    this.isDraggingSign = true; // Indicate that the file is being dragged
  }

  onDragLeaveSign(event: DragEvent) {
    event.preventDefault();
    this.isDraggingSign = false; // Reset the drag state
  }

  onFileDroppedSign(event: DragEvent) {
    event.preventDefault();
    this.isDraggingSign = false; // Reset the drag state

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handelSignFile(files[0]); // Process the first file
    }
  }
  checkupload: any;
  signfileNameForApiAppend: any
  onFileSelectedForSign(event: Event, item: any) {
    console.log(event);

    this.checkupload = item;
    const inputEvent = event.target as HTMLInputElement;


    if (inputEvent.files && inputEvent.files.length > 0) {
      this.handelSignFile(inputEvent.files[0]); // Process the selected file


    }

  }


  // For company letter head drag and drop 
  triggerFileInputcomapneletterhead() {

    const fileInput = document.querySelector('#browsecompanyletterheadImage') as HTMLInputElement;
    if (fileInput) {
      fileInput.click(); // Programmatically trigger the click event
      console.log(fileInput);

    }

  }

  isDraggingletterHead: boolean = false;
  onDragOverletterHead(event: DragEvent) {
    console.log(event);

    event.preventDefault(); // Prevent the default browser behavior
    this.isDraggingletterHead = true; // Indicate that the file is being dragged
  }

  onDragLeaveLetterHead(event: DragEvent) {
    event.preventDefault();
    this.isDraggingletterHead = false; // Reset the drag state
  }

  onFileDroppedLetterHead(event: DragEvent) {
    event.preventDefault();
    this.isDraggingletterHead = false; // Reset the drag state

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handelletterHeadFile(files[0]); // Process the first file
    }
  }
  onFileSelectedForletterHead(event: Event | null) {
    if (!event) {
      // Handle delete/reset case
      this.letterheadfileNameForApiAppend = null;
      // this.letterheadFilleFromBackendSide = null; // if you have this variable
      console.log('File cleared');
      return;
    }

    // Otherwise handle file selection
    const inputEvent = event.target as HTMLInputElement;
    if (inputEvent.files && inputEvent.files.length > 0) {
      const file = inputEvent.files[0];
      this.handelletterHeadFile(file); // Process selected file
      this.letterheadfileNameForApiAppend = file;
      // this.letterheadFilleFromBackendSide = file.name;
      console.log('File selected:', file.name);
    }
  }

  handleFile(file: File) {
    const fileSizeInKB = file.size / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;

    // Check file type and extension
    if (!file.name.match(/\.(csv|CSV|xlsx|XLSX|pdf|PDF|png|PNG|jpg|JPG|jpeg|JPEG)$/)) {
      window.alert("File format is not supported");
      return;
    }


    if (fileSizeInMB > 10) {
      window.alert("File size is greater than 10MB");
      return;
    }


    // File is valid
    this.fileName = file.name;
    this.fileType = file.type;
    this.formData = new FormData();
    this.formData.append('file', file);
    this.formData.append('companyId', this.loggedInUserCompanyID);
    this.showBrowseBtn = true;
    this.isDisabledUploadPolicyBtn = false;
    this.isFileSizeIsInvalid = false;

    // Optional: Read file content
    const reader = new FileReader();
    reader.onload = () => {
      this.fileContent = reader.result; // Store the file content
    };
    reader.readAsArrayBuffer(file); // Read the file as binary data

    //   const url = this.config.uploadFileLocally + `?fileName=${this.fileName}&fileType=${this.fileType}`;
    // this.httpService.submitFormService(url, this.formData).subscribe((data: any) => {
    //   this.letterHeadUrl = data?.data;
    // })
  }

  getYearSetup(event: any) {
    this.selectedYearForCompetency = event.value;
    this.getBAndAndGrade();

    // this.getAllEmployeeCodeData();
    // this.getprobationPeriods();
    this.getConfirmation();
    this.getAssignExit();
    // this.getSalaryBreckUpData();
    // this.getUploadLetterHead()

    // this.getUploadSign();
    // this.getSalaryBreckUpData();
    this.commanSetUpGetApiData();

  }
  isDisabledUploadPolicyBtnForSign: boolean = true;
  handelSignFile(file: File) {
    if (!file) return;

    const fileSizeInMB = file.size / (1024 * 1024);

    // ✅ Allowed image extensions only
    const allowedExtensions = ['png', 'jpg', 'jpeg'];
    const extension = file.name.split('.').pop()?.toLowerCase();

    if (!extension || !allowedExtensions.includes(extension)) {
      window.alert("Only image files are allowed (PNG, JPG, JPEG).");
      return;
    }

    // ✅ Restrict to 2 MB max
    if (fileSizeInMB > 2) {
      window.alert("File size should not exceed 2MB.");
      return;
    }

    this.signfileNameForApiAppend = file;
    this.signfileType = file.type;
    this.formDataForSign = new FormData();
    this.formDataForSign.append('file', file);
    this.formDataForSign.append('companyId', this.loggedInUserCompanyID);
    this.showSignBrowseBtn = true;
    this.isDisabledUploadPolicyBtnForSign = false;
    this.isFileSizeIsInvalid = false;

    // Optional: Read file content
    const signreader = new FileReader();
    signreader.onload = () => {
      this.signContent = signreader.result; // Store file content
    };
    signreader.readAsArrayBuffer(file); // Read binary data
  }

  letterheadfileNameForApiAppend: any;
  // handelletterHeadFile(file: File) {
  //   const fileSizeInKB = file.size / 1024;
  //   const fileSizeInMB = fileSizeInKB / 1024;

  //   console.log("Selected File:", file.name, "Type:", file.type); // Debugging

  //   // ❌ Strictly disallow .xlsx and .xls files
  //   if (file.name.match(/\.(xlsx|xls)$/i)) {
  //     window.alert("Excel files are not allowed.");
  //     return;
  //   }


  //   if (!file.name.match(/\.pdf$/i)) {
  //     window.alert("Only PDF files are allowed.");
  //     return;
  //   }
  //   // ✅ File size check (Limit: 10MB)
  //   if (fileSizeInMB > 10) {
  //     window.alert("File size is greater than 10MB.");
  //     return;
  //   }

  //   // ✅ Reset FormData before appending
  //   this.formDataForletterHead = new FormData();

  //   this.letterheadfileName = file.name;
  //   this.letterheadFilleFromBackendSide = file.name;
  //   this.letterheadfileType = file.type;

  //   // ✅ Append file data to FormData
  //   this.formDataForletterHead.append('file', file);
  //   this.formDataForletterHead.append('companyId', this.loggedInUserCompanyID);

  //   this.showletterHeadBrowseBtn = true;
  //   this.isDisabledUploadPolicyBtn = false;
  //   this.isFileSizeIsInvalid = false;

  //   console.log("Final FormData:", this.formDataForletterHead);

  //   // ✅ Read file content
  //   const letterHeadreader = new FileReader();
  //   letterHeadreader.onload = () => {
  //     this.letterContent = letterHeadreader.result; // Store file content
  //   };
  //   letterHeadreader.readAsArrayBuffer(file); // Read the file as binary data
  // }



  async handelletterHeadFile(file: File) {
    this.letterheadFilleFromBackendSide = null;
    const fileSizeInKB = file.size / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;

    console.log("Selected File:", file.name, "Type:", file.type);

    // ❌ Disallow Excel
    if (file.name.match(/\.(xlsx|xls)$/i)) {
      window.alert("Excel files are not allowed.");
      return;
    }

    // ❌ Allow only PDF
    if (!file.name.match(/\.pdf$/i)) {
      window.alert("Only PDF files are allowed.");
      return;
    }

    // ❌ Size check
    if (fileSizeInMB > 10) {
      window.alert("File size is greater than 10MB.");
      return;
    }

    // ✅ A4 Size Check (595 x 842 points = A4 at 72 DPI)
    const arrayBuffer = await file.arrayBuffer();
    const pdfDoc = await PDFDocument.load(arrayBuffer);
    const firstPage = pdfDoc.getPage(0);
    const { width, height } = firstPage.getSize();

    const expectedWidth = 595; // A4 width in points
    const expectedHeight = 842; // A4 height in points
    const tolerance = 2; // Allow small margin

    const isA4 = Math.abs(width - expectedWidth) <= tolerance && Math.abs(height - expectedHeight) <= tolerance;

    if (!isA4) {
      window.alert(`The uploaded PDF is not A4 size. Detected size: ${width} x ${height}`);
      return;
    }

    // ✅ Proceed if valid
    this.formDataForletterHead = new FormData();
    this.letterheadfileName = file.name;
    this.letterheadFilleFromBackendSide = file.name;
    this.letterheadfileType = file.type;

    this.formDataForletterHead.append('file', file);
    this.formDataForletterHead.append('companyId', this.loggedInUserCompanyID);

    this.showletterHeadBrowseBtn = true;
    this.isDisabledUploadPolicyBtn = false;
    this.isFileSizeIsInvalid = false;

    console.log("Final FormData:", this.formDataForletterHead);

    const letterHeadreader = new FileReader();
    letterHeadreader.onload = () => {
      this.letterContent = letterHeadreader.result;
    };
    letterHeadreader.readAsArrayBuffer(file);
  }

  onClickCancelUploadPolicy() {
    this.showBrowseBtn = false;
    this.isDisabledUploadPolicyBtn = true;
  }

  onClickCancelUploadSign() {
    this.showSignBrowseBtn = false;
    this.isDisabledUploadPolicyBtn = true;
  }
  checkProbationEmployee: any = []
  checkwmp: any
  chckPRobationEmployee() {
    this.httpService.callGetService(`${this.config.getEmployeeProbationCheck}/${this.loggedInUserId}/${this.loggedInUserCompanyID}`).subscribe((result: any) => {
      console.log(result)
      this.checkwmp = result.data.length > 0;
      this.checkProbationEmployee = result.data.length > 0 || this.checkLineManagerAndHod?.length || 0 === 0 && this.checkLineManagerAndHodForConfirm?.length || 0 === 0
      console.log(this.checkProbationEmployee);

    })
  }
  onClickUploadSign() {
    if (!this.signfileNameForApiAppend) {
      console.error("No file selected.");
      return;
    }

    const formData = new FormData();
    formData.append("file", this.signfileNameForApiAppend); // Must be a File object
    formData.append("companyId", this.loggedInUserCompanyID);
    formData.append("fileFor", "SIGNATURE");

    formData.append("candidateId", "");
    formData.append("uploadByUserId", String(this.loggedInUserId));
    formData.append("fiscalYear", this.loggedInCompanyFiscalyear);
    formData.append("year", this.selectedYearForCompetency);

    // Debug log
    formData.forEach((value, key) => console.log(key, value));

    this.httpService.submitFormService(this.config.uploadSignature, formData).subscribe({
      next: (result: any) => {
        if (result) {
          this.showBrowseBtn = false;
          this.isDisabledUploadPolicyBtnForSign = true;
          // this.getUploadSign();
          this.commanSetUpGetApiData();

          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: 'Sign successfully uploaded.',
              btn2: 'Done',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            },
          });

          dialogRef.afterClosed().subscribe(() => {
            this.dialog.closeAll();
          });
        }
      },
      error: (err) => {
        console.error("Upload error:", err);

        const errorMessage = err?.error?.message || 'Something went wrong during upload.';

        // Show error popup
        this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: errorMessage,
            btn2: 'OK',
            btn2BgColor: 'red',
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
      }
    });
  }


  onClickUploadPolicy() {

    // Ensure the file is valid
    if (!this.letterheadfileNameForApiAppend) {
      console.error("File is missing!");
      return;
    }

    // Create FormData
    const formData = new FormData();
    formData.append("file", this.letterheadfileNameForApiAppend); // Append file
    formData.append("fileFor", "Offer letter");
    formData.append("companyId", this.loggedInUserCompanyID);
    formData.append("candidateId", "");
    formData.append("uploadByUserId", String(this.loggedInUserId));
    formData.append("fiscalYear", this.loggedInCompanyFiscalyear);
    formData.append("year", this.selectedYearForCompetency);

    formData.forEach((value, key) => {
      console.log(`${key}:`, value);
    });
    // Step 1: Call the API first
    this.httpService.submitFormService(this.config.uploadOfferLetter, formData).subscribe((result: any) => {
      if (result) {
        // Step 2: Update states
        this.showBrowseBtn = false;
        this.isDisabledUploadPolicyBtn = true;
        // this.getUploadLetterHead();
        this.commanSetUpGetApiData();

        // Step 3: Show popup only after successful upload
        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: 'Letter head successfully uploaded.',
            btn2: 'Done',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });

        // Step 4: Handle what to do after popup is closed
        dialogRef.afterClosed().subscribe((popupResult) => {
          if (popupResult) {
            this.dialog.closeAll(); // Optional: Close other dialogs if needed
          }
        });
      }
    });

  }
  letterheadFilleFromBackendSide: any = '';
  filleFromBackendSide: any;

  checkbackendDataForSign: any


  onClickCancelUploadletterHead(letterHead: any, type: any) {

    if (type == 'letter') {
      if (letterHead && this.filleFromBackendSide != undefined) {

        this.httpService.callDeleteService(`${this.config.deleteLetterHead}?fileName=${letterHead}&companyId=${this.loggedInUserCompanyID}`)
          .subscribe((result: any) => {
            if (result) {

              // Success popup
              const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: result.message,
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                }
              });

              // Handle the result of the dialog
              dialogRef.afterClosed().subscribe(() => {
                // this.getUploadLetterHead();
                this.onFileSelectedForletterHead(null);
                this.commanSetUpGetApiData();
                this.letterheadFilleFromBackendSide = null;
              });

            }
          })
      }
      else {
        this.letterheadFilleFromBackendSide = null
        this.showletterHeadBrowseBtn = false;
        this.isDisabledUploadPolicyBtnForSign = true
      }
    } if (type === 'sign') {
      console.log('checkbackendDataForSign:', this.checkbackendDataForSign);
      if (this.checkbackendDataForSign !== undefined && letterHead) {

        this.httpService.callDeleteService(`${this.config.deleteLetterHead}?fileName=${letterHead}&companyId=${this.loggedInUserCompanyID}`)
          .subscribe((result: any) => {
            if (result) {

              // Success popup
              const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: result.message,
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                }
              });

              // Handle the result of the dialog
              dialogRef.afterClosed().subscribe(() => {

                // this.getUploadSign();
                this.commanSetUpGetApiData();
                this.signfileNameForApiAppend = null
              });

            }
          })
      } else {
        this.signfileNameForApiAppend = null
        this.showSignBrowseBtn = false;
        this.isDisabledUploadPolicyBtnForSign = true
      }
    }
    else {
      if (type == 'letter') {

        this.showletterHeadBrowseBtn = false;

        this.isDisabledUploadPolicyBtn = true;
      } else if (type == 'sign') {
        this.showSignBrowseBtn = false;
        this.isDisabledUploadPolicyBtnForSign = true
      }

    }
  }
  viewDocument(fileUrl: any): void {

    if (this.letterheadFilleFromBackendSide) {
      // Open the document in a new tab
      let fileUrls = `${this.config.downloadFile}${this.loggedInUserCompanyID}/${fileUrl}`;
      window.open(fileUrls, '_blank');
    } else {
      console.error('No document URL available');
    }
  }
  downloadSign(event: any) {
    if (event) {
      // Open the document in a new tab
      let fileUrl = `${this.config.downloadFile}${this.loggedInUserCompanyID}/${event}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }
  }


  //----------------------------------------------------------------------EmailBody-------------------------------------------------------

  // ---------------------------------------------------------probation and confirmation-----------------------------------------------------

  employeetendAccrossyear: any = []
  probstionPriodsData: any = []
  getBAndAndGrade() {
    this.httpService.callGetService(`${this.config.getBandAndGradeForProbation}?companyId=${this.loggedInUserCompanyID}`)
      .subscribe((record: any) => {
        console.log(record);
        // let filterData=record.data.filter((elm:any)=>elm.userId==this.loggedInUserId)
        this.employeetendAccrossyear = record.data.map((item: any) => {
          return {
            ...item,
            grades: item.grades.map((grade: any) => ({
              band: item.band,
              grade: grade,
              probationPeriod: null, // Assign probationPeriod at the grade level
              extensionPeriod: null
            }))
          };
        });
        this.getprobationPeriods()
        this.getNoticePeriodsForExit();
      });
  }

  getprobationPeriods() {
    this.httpService.callGetService(`${this.config.getProbation}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}`)
      .subscribe((record: any) => {
        console.log("API Response:", record);
        this.probstionPriodsData = [];
        this.probstionPriodsData = this.employeetendAccrossyear?.map((bandItem: any) => {
          return {
            ...bandItem,
            grades: bandItem.grades.map((gradeItem: any) => {
              const matchGrade = record.data.find((data: any) => data.grade === gradeItem.grade && data.band === gradeItem.band);
              return {
                ...gradeItem,
                probationId: matchGrade ? matchGrade.probationId : null,
                probationPeriod: matchGrade ? matchGrade.probationPeriod : null,
                extensionPeriod: matchGrade ? matchGrade.probationExtensionPeriod : null,
              };
            })
          };
        });


        setTimeout(() => {
          this.checkanydaysEmpty = this.probstionPriodsData?.some((bandItem: any) =>
            bandItem.grades.some((gradeItem: any) =>
              gradeItem.probationId == null ||
              gradeItem.extensionPeriod == null ||
              gradeItem.probationPeriod == null
            )
          );
          console.log(this.checkanydaysEmpty);
          sessionStorage.setItem("probationData", this.checkanydaysEmpty)
          console.log("Updated probation data:", this.probstionPriodsData);
          this.flag = JSON.parse(sessionStorage.getItem('probationData') || 'false');
          
        })


      });
  }


  editableIndex: number | null = null;
  editableSubIndex: number | null = null;
  selectedOptionForConfirmation: any;
  gradeData: any;
  noOfDaysConfirmation: any;
  probationSetupId: any;
  editFlagForConfirm: boolean = false
  // Function to enable edit mode
  onClickEdit(i: number, j: number) {
    this.editableIndex = i;
    this.editableSubIndex = j;
  }

  // Function to close edit mode
  onClickClose() {
    this.editableIndex = null;
    this.editableSubIndex = null;
    this.gradeData = null
    this.editFlagForConfirm = false;
    this.getprobationPeriods();
  }
  onClickEditConfirm() {
    this.editFlagForConfirm = true
  }
  onClickCloseForDays() {
    this.getConfirmation();
    this.editFlagForConfirm = false;
  }
  cancelData() { }
  onSelectionChangeConfirmation(event: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: `Are you sure you want to select "${event}"?`,
        btn2: 'Yes',
        btn1: 'No',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this.selectedOptionForConfirmation = event;

        this.saveConfirmation();

      } else {
        this.selectedOptionForConfirmation = null;
      }
    });
  }
  getconfirmationdata: any = [];
  getConfirmation() {
    this.httpService.callGetService(`${this.config.getConfirmationSetUp}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}`)
      .subscribe((record: any) => {
        this.getconfirmationdata = record.data;
        this.selectedOptionForConfirmation = record?.data[0]?.probationCurrentLogUserType || record?.data[1]?.probationCurrentLogUserType;
        this.probationSetupId = record?.data[0]?.probationSetupId || null;
        this.noOfDaysConfirmation = record?.data[0]?.noOfDayBeforeConfirmation;
        this.httpService.confirmationProbationWhomSetup = this.selectedOptionForConfirmation;


      })
  }


  saveConfirmation() {
    let a = this.selectedOptionForConfirmation == null || this.selectedOptionForConfirmation == "";
    let b = this.noOfDaysConfirmation == null || this.noOfDaysConfirmation == ""
    if (a) {
      this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Confirmation/probation extention intimation email to whom setup Pending',
          btn2: 'OK',
          btn2BgColor: 'red', // Highlight error with red button color
          showSuccessIcon: false,
          showSuccessMessage: false
        }
      });
      return; // Stops further iteration
    }
    if (b && this.probationSetupId) {
      this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'No of days is required',
          btn2: 'OK',
          btn2BgColor: 'red', // Highlight error with red button color
          showSuccessIcon: false,
          showSuccessMessage: false
        }
      });
      return; // Stops further iteration
    }
    let fromdata = {
      "probationSetupId": this.probationSetupId || null,
      "hrId": this.loggedInUserId,
      "companyId": this.loggedInUserCompanyID,
      "year": this.selectedYearForCompetency,
      "fiscalYear": this.loggedInCompanyFiscalyear,
      "probationCurrentLogUserType": this.selectedOptionForConfirmation,  // 1.LINE_MANAGER 2.HOD  // This should be one of the enum values
      "noOfDayBeforeConfirmation": this.noOfDaysConfirmation
    }
    this.httpService.callPostService(`${this.config.saveConfirmationSetUp}`, fromdata)
      .subscribe((data: any) => {

        if (data) {

          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe(() => {
            this.getConfirmation();
          });
          this.editFlagForConfirm = false;
        }
      },
        (error: any) => {

          const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: error.error.error || 'An error occurred while processing your request. Please try again.',
              btn2: 'OK',
              btn2BgColor: 'red', // Highlight error with red button color
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: true
            }
          });

          errorDialogRef.afterClosed().subscribe(() => {
            // Optionally handle any action after closing the error dialog
            console.log('Error dialog closed');
          });
        }
      )

  }

  addprobationPeriods(item: any, grade: any) {
    console.log(item);
    console.log(grade);
    this.gradeData = grade;
    this.saveprobationPeriods();
  }
  loading: boolean = false;
  isSubmitting: boolean = false;
  saveprobationPeriods() {
    if (!this.gradeData?.probationPeriod) {
      this.openErrorDialog('Probation period is required');
      return;
    }

    if (this.isSubmitting) return; // Prevent multiple clicks
    this.isSubmitting = true; // Set flag to true

    let formData = {
      probationId: this.gradeData?.probationId || null,
      hrId: this.loggedInUserId,
      companyId: this.loggedInUserCompanyID,
      year: this.selectedYearForCompetency,
      fiscalYear: this.loggedInCompanyFiscalyear,
      band: this.gradeData?.band,
      grade: this.gradeData?.grade,
      probationPeriod: this.gradeData?.probationPeriod,
      probationExtensionPeriod: this.gradeData?.extensionPeriod
    };

    this.loading = true;

    this.httpService.callPostService(`${this.config.saveBandAndGradeForProbation}`, formData)


      .subscribe({
        next: (data: any) => {
          this.isSubmitting = false; // Reset flag after response
          this.loading = false;
          const successMsg = this.gradeData?.probationId ? "Updated Successfully" : "Added Successfully";
          this.toastr.success(successMsg); // 👈 Show toast
          this.getprobationPeriods();
          this.checkSetUp();
        },
        error: (error: any) => {
          this.isSubmitting = false; // Reset flag on error
          this.loading = false;

          const errorMsg = this.gradeData?.probationId ? " Failed to updated" : "Failed to Added";
          this.toastr.error(errorMsg);
        }
      });
  }

  // ✅ Reusable Error Dialog Function
  openErrorDialog(message: string) {
    this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: 'OK',
        btn2BgColor: 'red', // Red color for errors
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
  }
  checkLineManagerAndHod: any = [];
  currentemployeesProbationDetails: any
  checkLineManagerAndHodForConfirm: any
  passDataForDashBoard: any
  checkForSameHODORMANAGER() {
    this.httpService.callGetService(`${this.config.getProbationDetails}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYearForCompetency}&fiscalType=${this.loggedInCompanyFiscalyear}`).subscribe((record: any) => {

      this.currentemployeesProbationDetails = record?.data;
      this.passDataForDashBoard = record?.data;
      console.log(record);

      this.checkLineManagerAndHod = this.currentemployeesProbationDetails?.filter((record: any) => ((record.hodCode == record.reportingManagerCode && this.selectedOptionForConfirmation === 'LINE_MANAGER') || (record.reportingManagerCode == this.loggedInUserEmpCode && this.selectedOptionForConfirmation === 'LINE_MANAGER')))
      console.log(this.checkLineManagerAndHod)

    })
    this.httpService.callGetService(`${this.config.getProbationDetailsConfirmationEmployee}/${this.loggedInUserCompanyID}`)
      .subscribe((response: any) => {
        if (!response || !response?.data) return;

        let currentemployeesProbationDetails = response.data
        this.checkLineManagerAndHodForConfirm = currentemployeesProbationDetails?.filter((record: any) => ((record.hodCode == record.reportingManagerCode && this.selectedOptionForConfirmation === 'LINE_MANAGER') || (record.reportingManagerCode == this.loggedInUserEmpCode && this.selectedOptionForConfirmation === 'LINE_MANAGER')))
      })

  }
  get shouldShowContainer(): boolean {


    const isValidRole =
      (this.loggedInUserRole === 'Manager' && this.selectedOptionForConfirmation === 'HOD') ||
      (this.loggedInUserRole === 'HOD' && this.selectedOptionForConfirmation === 'LINE_MANAGER');

    return isValidRole && (this.checkLineManagerAndHod?.length > 0 || this.checkLineManagerAndHodForConfirm?.length > 0);
  }

  addPerformanceRatingStandard(type: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '100%'; // Adjust as needed
    dialogConfig.width = '100%'; // Adjust as needed
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.disableClose = true; // Prevent closing via ESC or outside click
    dialogConfig.data = {
      type: type,
      setUp: "setUpView",
      companyID: this.loggedInUserCompanyID,
      year: this.selectedYearForCompetency,
    };
    dialogConfig.panelClass = 'custom-dialog-container';


    const dialogRef = this.dialog.open(AddRatingStanderdsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {


    });
  }

  changedFromEmployee() {
    console.log(this.checkwmp);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '100%'; // Adjust as needed
    dialogConfig.width = '100%'; // Adjust as needed
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.disableClose = true; // Prevent closing via ESC or outside click
    dialogConfig.data = {
      type: 'view',
      userId: this.loggedInUserId,
      checkhodbutEmployee: this.checkProbationEmployee,
      hrView: this.loggedInUserRole,
      companyID: this.loggedInUserCompanyID,
      year: this.selectedYearForCompetency,
      setUp: null,
    };
    dialogConfig.panelClass = 'custom-dialog-container';

    // const dialogRef = this.dialog.open(ProbationfromHODMANAGERComponent, dialogConfig);
    const dialogRef = this.dialog.open(AddRatingStanderdsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {


    });
  }
  // ------------------------------------------------------------------------------------EXIT----------------------------------------------------------------------------------
  options: number[] = [0, 0.5, 1, 2, 3, 4];
  probationOptions: number[] = [3, 6, 9, 12];
  probationOption1: number[] = [0, 1, 2, 3];
  optionsforExtend: number[] = [0, 0.5, 1, 2, 3, 4];
  selectedValue: any;


  selectedOptionForExit: any;
  probstionPriodsDataForExit: any;
  checkExitsetupcompletedornot: any
  getNoticePeriodsForExit() {
    this.httpService.callGetService(`${this.config.getNoticePeriods}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}`)
      .subscribe((record: any) => {
        console.log("API Response:", record);
        let probationData: any = [] = record?.data;


        this.probstionPriodsDataForExit = this.employeetendAccrossyear?.map((bandItem: any) => {
          return {
            ...bandItem,
            grades: bandItem.grades.map((gradeItem: any) => {
              const matchGrade = probationData.find((data: any) => data.grade === gradeItem.grade && data.band === gradeItem.band);
              return {
                ...gradeItem,
                noticePeriodId: matchGrade ? matchGrade.noticePeriodId : null,
                probationDuration: matchGrade ? matchGrade.probationDuration : null,
                probationConfirmation: matchGrade ? matchGrade.probationConfirmation : null,
              };
            })
          };
        });

        // console.log("Updated probation data:", this.probstionPriodsData);
        // this.checkExitsetupcompletedornot = this.probstionPriodsDataForExit
        //   ?.flatMap((bandObj: any) => bandObj.grades) // flatten all grades
        //   .filter((elm: any) =>
        //     (elm?.probationDuration == null && elm?.probationDuration !== 0 && elm.probationConfirmation == null && elm?.probationConfirmation !== 0)

        //   );

          setTimeout(() => {
          this.checkExitsetupcompletedornot = this.probstionPriodsDataForExit?.some((bandItem: any) =>
            bandItem.grades.some((gradeItem: any) =>
              gradeItem.probationDuration == null ||
              gradeItem.probationConfirmation == null ||
              gradeItem.noticePeriodId == null
            )
          );
   
         
          console.log("Updated probation data4444444:", this.probstionPriodsDataForExit);
          console.log("Incomplete Records (both missing):", this.checkExitsetupcompletedornot);
        
          // this.flag = JSON.parse(sessionStorage.getItem('probationData') || 'false');
        },100)


      });
        
  }


  onSelectionChangeConfirmationExit(event: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: `Are you sure you want to select "${event}"?`,
        btn2: 'Yes',
        btn1: 'No',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this.selectedOptionForExit = event;

        this.saveConfirmationExit();

      } else {
        this.selectedOptionForExit = null;
      }
    });
  }

  saveConfirmationExit() {

    let fromdata = {

      "hrId": this.loggedInUserId,
      "hrMail": this.userEmail,
      "companyId": this.loggedInUserCompanyID,
      "year": this.selectedYearForCompetency,
      "fiscalYear": this.loggedInCompanyFiscalyear,
      "assignRoles": this.selectedOptionForExit,
    }
    this.httpService.callPostService(`${this.config.saveAssignSetUpForExit}`, fromdata)
      .subscribe((data: any) => {

        if (data) {

          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe(() => {
            this.getAssignExit();
          });
          this.editFlagForConfirm = false;
        }
      },
        (error: any) => {

          const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: error.error.error || 'An error occurred while processing your request. Please try again.',
              btn2: 'OK',
              btn2BgColor: 'red', // Highlight error with red button color
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: true
            }
          });

          errorDialogRef.afterClosed().subscribe(() => {
            // Optionally handle any action after closing the error dialog
            console.log('Error dialog closed');
          });
        }
      )

  }
  noDueForm(event: any) {
    this.dialog.closeAll(); // Close any open dialogs

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = window.innerWidth <= 576 ? '95%' : '80%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.panelClass = 'phi-mdc-dialog__container';
    dialogConfig.data = {
      employeeData: event?.employeeData || null,
      year: this.selectedYearForCompetency,
      companyId: this.loggedInUserCompanyID
    };

    setTimeout(() => {
      const dialogRef = this.dialog.open(NoDueFormComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(() => {
        console.log('No Due Form closed.');
      });
    }, 100);
  }

  checkassign: any = []
  getAssignExit() {
    this.httpService.callGetService(`${this.config.getAssignSetUpForExit}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency} `)
      .subscribe((record: any) => {
        this.checkassign = record?.data;

        this.selectedOptionForExit = record?.data[0]?.assignRoles;
        this.httpService.selectedOptionForExitPermission = this.selectedOptionForExit;

      })
  }
  addprobationPeriodsforExit(item: any, grade: any) {
    console.log(event);
    console.log(grade);
    this.gradeData = grade;

    this.saveprobationPeriodsForNoticePeriods();

  }

  saveprobationPeriodsForNoticePeriods() {
    console.log(this.gradeData);


    if (this.isSubmitting) return; // Prevent multiple clicks
    this.isSubmitting = true; // Set flag to true

    let formData = {
      noticePeriodId: this.gradeData?.noticePeriodId || null,
      hrId: this.loggedInUserId,
      companyId: this.loggedInUserCompanyID,
      year: this.selectedYearForCompetency,
      fiscalYear: this.loggedInCompanyFiscalyear,
      band: this.gradeData?.band,
      grade: this.gradeData?.grade,
      probationDuration: this.gradeData?.probationDuration,
      probationConfirmation: this.gradeData?.probationConfirmation
    };

    this.loading = true;

    this.httpService.callPostService(`${this.config.addupdateNoticeperiods}`, formData)
      .subscribe({
        next: (data: any) => {
          this.isSubmitting = false; // Reset flag after response
          this.loading = false;
          const successMsg = this.gradeData?.noticePeriodId ? "Updated Successfully" : "Added Successfully";
          this.toastr.success(successMsg); // 👈 Show toast
          this.getNoticePeriodsForExit();
        },
        error: (error: any) => {
          this.isSubmitting = false; // Reset flag on error
          this.loading = false;

          const errorMsg = this.gradeData?.noticePeriodId ? " Failed to updated" : "Failed to Added";
          this.toastr.error(errorMsg);
        }
      });
  }

  onClickback() {
    // Hide dashboard first (forces re-render)
    this.selectedTypeTabName = '';

    setTimeout(() => {
      // Show dashboard again after small delay
      this.selectedTypeTabName = 'Dashboard';

      // Navigate to main dashboard route (optional)
      this.router.navigate(['/home/hrportal/elcm']);
    }, 100);
  }

  // ---------------------------------------------remove api ------------------------------------------------------------------------------
  getUploadLetterHead() {
    this.httpService.callGetService(this.config.getOfferLetter + this.loggedInUserCompanyID + '?fileFor=Offer letter&year=' + this.selectedYearForCompetency)
      .subscribe((result: any) => {
        console.log(result.data);
        if (result && result.data != null) { // Check for string "null"
          this.letterheadFilleFromBackendSide = result.data; // Assign valid data


          this.filleFromBackendSide = result.data
          this.showletterHeadBrowseBtn = true;
        } else {
          this.letterheadFilleFromBackendSide = ''; // Ensure it's empty if "null" or actually null
          this.showletterHeadBrowseBtn = false;
        }

        this.cdr.detectChanges(); // Ensure UI updates
      });
  }
  getUploadSign() {
    this.httpService.callGetService(this.config.getOfferLetter + this.loggedInUserCompanyID + '?fileFor=SIGNATURE&year=' + this.selectedYearForCompetency)
      .subscribe((result: any) => {
        console.log(result.data);
        if (result.data != null) { // Check for string "null"
          this.checkbackendDataForSign = result.data;
          this.signfileNameForApiAppend = result.data; // Assign valid data
          this.showSignBrowseBtn = true;


        } else {
          this.signfileNameForApiAppend = ''; // Ensure it's empty if "null" or actually null
          this.showSignBrowseBtn = false;
          this.isDisabledUploadPolicyBtnForSign = true
        }

        this.cdr.detectChanges(); // Ensure UI updates
      });
  }
  getAllEmployeeCodeData() {
    // let formData = {

    //   "companyId": this.loggedInUserCompanyID,
    //   "changeByUserId":this.loggedInUserId,
    //   "year": this.selectedYearForCompetency


    // }


    this.httpService.callGetService(`${this.config.getAllEmployeeCode}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}`).subscribe((resp: any) => {
      this.getEmployeeCodeDataList = [];
      this.selectedcodecreateOption = '';
      this.setPrefix = '';
      this.setLimit = '';
      if (resp.data) {

        this.getEmployeeCodeDataList = resp?.data[0];
        this.flagData = resp?.data;
        this.updateFlag = this.getEmployeeCodeDataList ? true : false;
        this.setPrefix = this.getEmployeeCodeDataList?.companyPrefix;
        this.setLimit = this.getEmployeeCodeDataList?.startNumber;
        this.selectedDeptLocation = this.getEmployeeCodeDataList?.employeeCodeSelection || 'none';
        this.selectedcodecreateOption = this.getEmployeeCodeDataList.isManual ? 'manual' : 'auto';

        this.httpService.setEmployeeCodeData(this.getEmployeeCodeDataList);
      }
    })
  }
}
